import * as React from 'react';

import Modal from 'antd/lib/modal';

import candleImg from '@images/link-icons/candle.svg';

import '@app/scss/components/vetTesModal.scss';
import {TesAuthorCredits, VetAvatar} from '@app/components/UI/VetTesCard/VetTesCard';
import PetMemorialGallery from '@app/components/Pages/PetMemorial/PetMemorialModalGallery';
import NavSelectMobile from '@app/components/UI/NavSelectMobile/NavSelectMobile';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

const PetMemorialPreviewModal = ({
	modalVisible,
	setModalVisible,
	memorial
}) => {
	const navItems = [
		{name: 'memory', title: `In loving memory of ${memorial.petName ? memorial.petName : 'your pet'}`},
		{name: 'about', title: `${memorial.petName ? memorial.petName : 'your pet'}'s Story`},
	];

	const [currentIndex, setCurrentIndex] = React.useState(0);
	const currentIssue = navItems[currentIndex].name;
	const [navCollapse, setNavCollapse] = React.useState(false);
	const onSetIssue = (index) => {
		setCurrentIndex(index);
	};
	const onChange = (index) => {
		setCurrentIndex(index);
	};

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setNavCollapse(true);
			} else {
				setNavCollapse(false);
			}

		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, [currentIndex]);

	const modalProps = memorial.images ? {memorial: {images: memorial.images}} : '';

	return (
		<Modal
			wrapClassName="modal-wrap pet-mem-preview-modal"
			visible={modalVisible}
			onOk={() => setModalVisible(false)}
			onCancel={() => setModalVisible(false)}
			width={1037}
			centered
		>
			{memorial &&
				<div className="pet-mem-modal__content">
					<div className="pet-mem-modal__container">
						<header className="pet-mem-modal__content-header">
							<div className="pet-mem-modal__content-header-title">
								<h4>{memorial.petName}</h4>
								<div>
									<span>{memorial.dateBirth}</span>
									{memorial.dateBirth && <span> - </span>}
									<span>{memorial.datePass || '...'}</span>
								</div>
							</div>
							<div className="pet-mem-modal__content-header-nav">
								{memorial.memorialCandles?.length > 0 &&
								<div className="pet-mem-modal__content-header-candle">
									<img src={candleImg} alt="candle"/>
									<span>{memorial.memorialCandles.length}</span>
								</div>
								}
								<button className="btn btn-sm btn-primary" onClick={() => {
								}}>
									Light a candle
								</button>
							</div>
						</header>
						<PetMemorialGallery navCollapse={navCollapse} modalProps={modalProps}/>
						{
							navCollapse
								?
								<div className="nav-select-mobile__wrapper">
									<button className="btn btn-primary" onClick={() => {}}>
										Light a candle
									</button>
									<NavSelectMobile
										navItems={navItems}
										onChange={onChange}
										currentIndex={currentIndex}
									/>
								</div>
								:
								<div className="pet-mem-modal__content-nav">
									{navItems && navItems.map((item, index) =>
										<button
											key={index}
											className={currentIndex === index ? 'pet-mem-modal__content-nav-button active' : 'pet-mem-modal__content-nav-button'}

											onClick={() => onSetIssue(index)}
										>
											{item.title}
										</button>)}
								</div>
						}
						<div className="pet-mem-modal__content-issues">
							<div className="pet-mem-modal__content-topic">
								{
									currentIssue === 'memory' ?
										<p>
											{memorial.message}
										</p>
										:
										<p>
											{memorial.story}
										</p>

								}
							</div>
							<TesAuthorCredits
								firstName={memorial.firstName}
								lastName={memorial.lastName}
								city={memorial.city}
								state={memorial.state}
								date={memorial.datePost}
								isShowName={memorial.isShowName}
							/>
						</div>
					</div>
				</div>
			}
		</Modal>
	);
};

export default PetMemorialPreviewModal;